export enum PickingSlide {
    Canceled = "Canceled",
    Checked = "Checked"
}